
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ProductsSection from './components/ProductsSection';
import ApplicationsSection from './components/ApplicationsSection';
import FeaturesSection from './components/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import SchemaMarkup from '../../components/base/SchemaMarkup';

const homeSchema = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "MADLIENA Landmark Ltd - Redsail Laser Malta",
    "url": "https://redsaillaser-malta.com",
    "logo": "https://static.readdy.ai/image/a51c03b2382e35c3e6bd6650ef5c1522/dbc4baadda575218bf3f908f312356a6.png",
    "description": "Official Malta distributor of Redsail CO2 laser cutting and engraving machines. Professional laser solutions for businesses.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "47, Triq il Gladjoli",
      "addressLocality": "Madliena",
      "addressCountry": "MT",
      "postalCode": "SWQ2023"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+356-9944-6552",
      "contactType": "sales",
      "availableLanguage": ["English", "Maltese"]
    },
    "sameAs": [
      "https://wa.me/35699446552"
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "MADLIENA Landmark Ltd",
    "image": "https://static.readdy.ai/image/a51c03b2382e35c3e6bd6650ef5c1522/dbc4baadda575218bf3f908f312356a6.png",
    "description": "Official Malta distributor of Redsail laser cutting and engraving machines",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "47, Triq il Gladjoli",
      "addressLocality": "Madliena",
      "addressCountry": "MT",
      "postalCode": "SWQ2023"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "35.9375",
      "longitude": "14.5146"
    },
    "telephone": "+356-9944-6552",
    "email": "grtrophy@gmail.com",
    "vatID": "MT 29045621",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "10:00",
        "closes": "14:00"
      }
    ],
    "priceRange": "$$"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Redsail Laser Malta - Official Distributor",
    "description": "Professional CO2 laser cutting and engraving machines in Malta. Industrial, professional and desktop laser solutions.",
    "url": "https://redsaillaser-malta.com",
    "mainEntity": {
      "@type": "ItemList",
      "name": "Laser Machine Categories",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Industrial Laser Cutters" },
        { "@type": "ListItem", "position": 2, "name": "Flatbed Laser Cutters" },
        { "@type": "ListItem", "position": 3, "name": "High Power Laser Cutters" },
        { "@type": "ListItem", "position": 4, "name": "Desktop Laser Engravers" }
      ]
    }
  }
];

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={homeSchema} />
      <Navbar />
      <HeroSection />
      <StatsSection />
      <ProductsSection />
      <ApplicationsSection />
      <FeaturesSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
